// Directly called by accordion card-header on click
function toggle(header) {
  // 1. Handle closing other open cards
  const accordion = header.closest(".accordion");
  const expandedElement = findExpandedElement(accordion);

  // if there is no expanded element, ignore
  if (expandedElement !== undefined) {
    // if the expanded element is the target element, ignore
    if (expandedElement.firstElementChild.id !== header.id) {
      close(expandedElement);
    }
  }

  // 2. Handle target element toggle (indiscriminate)
  // html elements
  const content = header.nextElementSibling;
  const body = content.firstElementChild;

  // find relevant expanded data
  const expanded = header.getAttribute("aria-expanded") === "false";
  // const height = body.offsetHeight; // changed to fit-content to account for adjustable content (mw 2025/02/28)

  // apply data
  header.setAttribute("aria-expanded", expanded);

  if (expanded) {
    content.setAttribute("style", `height: fit-content;`);
    setTimeout(() => {
      const rect = header.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
          const targetScroll = window.scrollY + rect.top - 250;
          window.scrollTo({ top: targetScroll, behavior: "smooth" });
      }
      }, 500);

      // for rentals step status
      const stepStatusElement = header.querySelector(".step-status");
      if (stepStatusElement && stepStatusElement.dataset.status === "not-started") {
        stepStatusElement.setAttribute("data-status", "in-progress");
        stepStatusElement.setAttribute("data-value", `Step ${stepStatusElement.dataset.step} incomplete` );
      } 

  } else {
    content.setAttribute("style", "");
  }
}

// helper function to isolate the card that is open
function findExpandedElement(accordion) {
  for (let card of accordion.children) {
    const header = card.firstElementChild;
    const expanded = header.getAttribute("aria-expanded") === "true";
    if (expanded) {
      return card;
    }
  }
}

// helper function to close an already open card
function close(card) {
  const header = card.firstElementChild;
  header.setAttribute("aria-expanded", false);

  const content = header.nextElementSibling;
  content.setAttribute("style", "");
}

// bullet points (handled once on render)
let ps = document.querySelectorAll(".accordion p");
ps.forEach(p => {
  if (p.innerText[0] === "-") {
    const ul = document.createElement("ul");
    ul.className = "bullets";

    let bullets = p.innerHTML.split("- ");
    bullets.shift();

    bullets.forEach(bullet => {
      const li = document.createElement("li");
      li.innerHTML = bullet;
      ul.appendChild(li);
    });
    
    let parent = p.parentElement;
    parent.replaceChild(ul, p);
  }
});